type CurveCoordinate = { x: number; y: number }

const svgNumber = (value: number) => value.toFixed(2)

export function monotoneCurvePath(points: CurveCoordinate[]): string {
  if (points.length === 0) return ""

  const start = `M${svgNumber(points[0].x)} ${svgNumber(points[0].y)}`
  if (points.length === 1) return start

  const intervals = points.slice(1).map((point, index) => {
    const previous = points[index]
    const width = point.x - previous.x
    return { width, slope: (point.y - previous.y) / width }
  })
  if (intervals.some(({ width }) => width <= 0)) {
    return (
      start +
      points
        .slice(1)
        .map((point) => ` L${svgNumber(point.x)} ${svgNumber(point.y)}`)
        .join("")
    )
  }

  const tangents = points.map((_, index) => {
    if (index === 0) return intervals[0].slope
    if (index === points.length - 1) return intervals[intervals.length - 1].slope

    const before = intervals[index - 1]
    const after = intervals[index]
    if (
      before.slope === 0 ||
      after.slope === 0 ||
      Math.sign(before.slope) !== Math.sign(after.slope)
    ) {
      return 0
    }

    const beforeWeight = 2 * after.width + before.width
    const afterWeight = after.width + 2 * before.width
    return (beforeWeight + afterWeight) / (beforeWeight / before.slope + afterWeight / after.slope)
  })

  return (
    start +
    intervals
      .map(({ width }, index) => {
        const from = points[index]
        const to = points[index + 1]
        const first = { x: from.x + width / 3, y: from.y + (tangents[index] * width) / 3 }
        const second = { x: to.x - width / 3, y: to.y - (tangents[index + 1] * width) / 3 }
        return ` C${svgNumber(first.x)} ${svgNumber(first.y)} ${svgNumber(second.x)} ${svgNumber(second.y)} ${svgNumber(to.x)} ${svgNumber(to.y)}`
      })
      .join("")
  )
}
